import React from "react";
import { useSelector } from "react-redux";
import { Divider, Flex, Space, Spin, Typography } from "antd";
const { Text, Paragraph } = Typography;
import { CheckCircleFilled, LoadingOutlined } from "@ant-design/icons";

export const WhatsappBusinessNUmberList = ({
  selectBusinessNumber = () => {},
}) => {
  const {
    whatsappBusinessNumbersList: { wapp_business_num, wapp_business_num_count },
    whatsappBusinessNumbersListLoading,
    page_business_number,
    listingWhatsappBusinessNumbersListError,
    saveWabaBusinessLoading,
  } = useSelector((state) => state.Channel);

  const formatPhoneNumber = (number, countryCode) => {
    return `${countryCode} ${number}`;
  };

  const daily_messaging_limit = {
    TIER_50: 50,
    TIER_100: 100,
    TIER_250: 250,
    TIER_1K: 1000,
    TIER_10K: 10000,
    TIER_100K: 100000,
    TIER_UNLIMITED: 100000000,
  };

  const quality_rating = {
    UNKNOWN: "Unknown",
    GREEN: "High",
    RED: "Low",
    YELLOW: "Medium",
  };

  const quality_rating_styles = {
    High: "var(--primary)",
    Medium: "var(--secondary)",
    Low: "#f96056",
    Unknown: "var(--primary)",
  };

  return (
    <Flex
      vertical
      gap={"small"}
      className="p-4 max-h-[40vh] min-w-[30vw] overflow-scroll"
    >
      {whatsappBusinessNumbersListLoading ? (
        <Spin
          indicator={<LoadingOutlined spin />}
          size="large"
          className="w-[20vw] m-auto"
        />
      ) : (
        wapp_business_num?.map((number, i) => {
          return (
            <Space
              direction="vertical"
              key={number?.id}
              className="px-4 hover:cursor-pointer"
              onClick={() =>
                !saveWabaBusinessLoading &&
                number.id != page_business_number?.id &&
                selectBusinessNumber(number.id)
              }
            >
              <Flex justify="space-between" align="center">
                <Flex vertical size="middle" gap={10}>
                  <Space>
                    <Text strong>{number.send_from_phone_name}</Text>
                  </Space>
                  <Space>
                    <Text type="secondary">
                      {formatPhoneNumber(
                        number?.send_from_phone_number,
                        number?.country_code,
                      )}
                    </Text>
                    <Divider type="vertical" className="bg-gray-400" />
                    <Space>
                      <Paragraph
                        className="size-4"
                        style={{
                          backgroundColor:
                            quality_rating_styles[
                              quality_rating[number?.quality_rating]
                            ],
                          margin: 0,
                        }}
                      />
                      <Text
                        style={{
                          color:
                            quality_rating_styles[
                              quality_rating[number?.quality_rating]
                            ],
                        }}
                      >
                        {quality_rating[number?.quality_rating]}
                      </Text>
                    </Space>
                    <Divider type="vertical" className="bg-gray-400" />

                    <Text>
                      {daily_messaging_limit[number?.daily_messaging_limit]}
                    </Text>
                  </Space>
                </Flex>
                <div className="size-4 flex items-center justify-center border border-gray-400 rounded-full cursor-pointer">
                  {number.id == page_business_number?.id ? (
                    <CheckCircleFilled className="text-green-500 text-lg" />
                  ) : null}
                </div>
              </Flex>
              {i != wapp_business_num_count - 1 && <Divider className="my-3" />}
            </Space>
          );
        })
      )}
    </Flex>
  );
};
